import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import { Spin } from 'antd';

const ReportsManagementView = lazy(() =>
  import('./views/ReportsManagementView').then((module) => ({
    default: module.ReportsManagementView,
  }))
);

const TemplateListPage = lazy(() =>
  import('./views/TemplateListPage').then((module) => ({
    default: module.TemplateListPage,
  }))
);

const LoadingFallback = () => (
  <div className="flex items-center justify-center h-screen">
    <Spin size="large" tip="Loading..." />
  </div>
);

export const reportsManagementRoutes: RouteObject[] = [
  {
    path: '/admin/reports/management',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <ReportsManagementView />
      </Suspense>
    ),
  },
  {
    path: '/admin/reports/templates',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <TemplateListPage />
      </Suspense>
    ),
  },
];
